export default __webpack_public_path__ + "images/stepFooter.8f7f8ae3.svg";